import {
  ClickAwayListener,
  Divider,
  Grow,
  List,
  Paper,
  Popper,
  PopperPlacementType,
} from '@mui/material';

import { AnchorMenuItem } from '../AnchorMenuItem';
import { MenuItem } from '../Menu.types';
import { usePopupStyle } from './Popup.styles';

export type PopupProps = {
  anchorRef: any;
  items: Array<MenuItem>;
  open: boolean;
  placement: PopperPlacementType;
  preventParentClose?: boolean;
  closeParentPopup: () => void;
  handleClose: (e: any) => void;
  setPreventParentClose?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Popup = ({
  anchorRef,
  items,
  open,
  placement,
  preventParentClose,
  closeParentPopup,
  handleClose,
  setPreventParentClose,
}: PopupProps) => {
  const classes = usePopupStyle();

  return (
    <Popper
      anchorEl={anchorRef.current}
      className={classes.popup}
      onMouseEnter={() => {
        setPreventParentClose(true);
      }}
      onMouseLeave={() => {
        setPreventParentClose(false);
      }}
      open={open || preventParentClose}
      placement={placement}
      role="tooltip"
      transition
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper className={classes.paper}>
            <ClickAwayListener mouseEvent="onMouseDown" onClickAway={handleClose}>
              <List>
                {items.map((item, index) => {
                  const key = item.text + index;
                  return item.divider ? (
                    <Divider key={key} />
                  ) : (
                    <AnchorMenuItem
                      key={key}
                      item={item}
                      closeParentPopup={closeParentPopup}
                      popupPlacement="right"
                    />
                  );
                })}
              </List>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
